import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import About from './pages/About';
import CV from './pages/CV';
import Qcm from './pages/Qcm';
import QcmPlay from './pages/QcmPlay';
import QcmSubject from './pages/QcmSubject';
import Notes from './pages/Notes';
import Plans from './pages/Plans';
import NoteDetail from './pages/NoteDetail';
import NotesSubject from './pages/NotesSubject';
import Cards from './pages/Cards';
import CardsPlay from './pages/CardsPlay';
import Login from './pages/Login';
import Admin from './pages/Admin';
import RequireAuth from './components/RequireAuth';

function PublicLayout({ children }) {
  return (
    <>
      <Nav />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin/*" element={<RequireAuth><Admin /></RequireAuth>} />
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/articles" element={<PublicLayout><Articles /></PublicLayout>} />
      <Route path="/articles/:slug" element={<PublicLayout><ArticleDetail /></PublicLayout>} />
      <Route path="/plans" element={<PublicLayout><Plans /></PublicLayout>} />
      <Route path="/notes" element={<PublicLayout><Notes /></PublicLayout>} />
      <Route path="/notes/sujet/:id" element={<PublicLayout><NotesSubject /></PublicLayout>} />
      <Route path="/notes/:slug" element={<PublicLayout><NoteDetail /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/cv" element={<PublicLayout><CV /></PublicLayout>} />
      <Route path="/qcm" element={<PublicLayout><Qcm /></PublicLayout>} />
      <Route path="/qcm/sujet/:id" element={<PublicLayout><QcmSubject /></PublicLayout>} />
      <Route path="/qcm/:id" element={<QcmPlay />} /> {/* plein écran, sans menu : mode « jeu » */}
      <Route path="/experiences" element={<Navigate to="/qcm" replace />} />
      <Route path="/cards" element={<PublicLayout><Cards /></PublicLayout>} />
      <Route path="/cards/:id" element={<CardsPlay />} /> {/* plein écran, façon Reels */}
      <Route path="/tutorials/*" element={<Navigate to="/cards" replace />} />
      <Route path="*" element={<PublicLayout><div className="section"><h2>Page introuvable</h2></div></PublicLayout>} />
    </Routes>
  );
}
